// Vuex object/icon store module

import champions from '@/assets/champions.json'
import items     from '@/assets/items.json'

const imagePath = './static/img'
const icons     = []

Object.keys(champions.data).forEach(key => {
  const championData = champions.data[key]
  const championIcon = {
    id    : `champion_${championData.id}`,
    key   : championData.key,
    name  : championData.name,
    image : `${imagePath}/champion/${championData.image.full}`,
    type  : 'champion',
    tags  : [
      ...championData.tags
    ],
    spells: championData.spells.map(spell => {
      const championSpell = {
        id    : `spell_${spell.key}`,
        name  : spell.name,
        image : `${imagePath}/spell/${spell.image.full}`
      }
      icons.push(championSpell)
      return `spell_${spell.key}`
    }),
    passive : `passive_${championData.key}`,
    items   : []
  }
  icons.push(championIcon)

  icons.push({
    id    : `passive_${championData.key}`,
    name  : championData.passive.name,
    image : `${imagePath}/passive/${championData.passive.image.full}`
  })
})

Object.keys(items.data).forEach(key => {
  const itemData = items.data[key]
  const itemIcon = {
    id     : `item_${itemData.id}`,
    name   : itemData.name,
    image  : `${imagePath}/item/${itemData.image.full}`,
    type   : 'item',
    tags   : [],
    colloq : itemData.colloq,
    gold   : itemData.gold.total
  }

  icons.push(itemIcon)
})

export default icons



// WEBPACK FOOTER //
// ./src/assets/icons.js